// JsFromRoutes CacheKey d7814a116e9d7096b544337517338061
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  connect: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/calendar/connect'),
  callback: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/calendar/callback'),
  disconnect: /* #__PURE__ */ definePathHelper('delete', '/:org_nano_id/calendar/disconnect'),
}
